import { Reference } from '@apollo/client';

export type CachedListField = {
  data?: readonly Reference[];
  count?: number | null;
};

export const isCachedListField = (value: unknown): value is CachedListField =>
  typeof value === 'object' && value !== null && 'data' in value;

export const readFieldArgs = (storeFieldName: string): Record<string, unknown> => {
  const argsStart = storeFieldName.indexOf('{');
  if (argsStart === -1) return {};

  try {
    return JSON.parse(storeFieldName.slice(argsStart)) as Record<string, unknown>;
  } catch {
    return {};
  }
};
